import { render, staticRenderFns } from "./UserSecurityLocks.vue?vue&type=template&id=50f32508&scoped=true&"
import script from "./UserSecurityLocks.vue?vue&type=script&lang=js&"
export * from "./UserSecurityLocks.vue?vue&type=script&lang=js&"
import style0 from "./UserSecurityLocks.vue?vue&type=style&index=0&id=50f32508&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f32508",
  null
  
)

export default component.exports